import { initCatalog } from '~/ci/catalog/';

initCatalog();
